export const minimumTopUpMinor = (excessScaled: number): number => Math.max(1, Math.ceil(excessScaled / 100));

export const formatMinor = (minor: number): string =>
    `${Math.floor(minor / 100)}.${String(minor % 100).padStart(2, '0')}`;
